const SideMenuLangKey = [
	'affiliate_title',
	'offer_scope_title',
	'offer_spend_title',
	'offer_spend_report_title',
	'offer_spend_report_by_account_title',
	'offer_spend_report_by_offer_title',
	'offer_spend_report_by_offer_scope_title',
	'postback_send_title',
	'revenue_agency_title',
	'revenue_spend_title',
	'revenue_spend_report_by_account_title',
	'revenue_spend_report_by_team_title',
	'account_title',
	'role_title',
	'job_title',
	'project_title',
	'login_title',
	'logout_title'
] as const

type ISideMenuLangKey = typeof SideMenuLangKey[number]

export type ISideMenuLang = {
	side_menu: Record<ISideMenuLangKey, string>
}

const langEntries = SideMenuLangKey.map(
	(key: ISideMenuLangKey) => [key, `side_menu.${key}`]
)

const langObj: Record<ISideMenuLangKey, string> = Object.fromEntries(langEntries)

export const SIDE_MENU_LANG_KEY: ISideMenuLang = {
	side_menu: langObj
}

